/**
 * AMP Back in Stock: notify form lives in #BIS_frame. Parent CSS does not apply inside the iframe.
 * Inject @font-face + font-family into the iframe document when it is same-origin (e.g. about:blank + injected HTML).
 * Expects window.__bisIframeFontAssets { textWoff2, mediumWoff2 } from theme.liquid.
 */
(function () {
  function injectIntoFrame(iframe) {
    if (!iframe || iframe.id !== 'BIS_frame') return false;

    var doc;
    try {
      doc = iframe.contentDocument || (iframe.contentWindow && iframe.contentWindow.document);
    } catch (e) {
      return false;
    }

    if (!doc || !doc.documentElement) return false;

    var assets = window.__bisIframeFontAssets;
    if (!assets || !assets.textWoff2 || !assets.mediumWoff2) return false;

    var head = doc.head || doc.getElementsByTagName('head')[0];
    if (!head) return false;

    if (head.querySelector('style[data-bis-font-inject]')) return true;

    var style = doc.createElement('style');
    style.setAttribute('data-bis-font-inject', '1');

    var t = assets.textWoff2;
    var m = assets.mediumWoff2;

    style.textContent =
      "@font-face{font-family:'GT-Pressura-Mono-Text';src:url('" +
      t +
      "') format('woff2');font-weight:400;font-style:normal;font-display:swap;}" +
      "@font-face{font-family:'GT-Pressura-Mono-Medium';src:url('" +
      m +
      "') format('woff2');font-weight:600;font-style:normal;font-display:swap;}" +
      "body,body *{font-family:'GT-Pressura-Mono-Text',sans-serif !important;}" +
      "h1,h2,h3,.esc-out-of-stock-title,[class*='title']{font-family:'GT-Pressura-Mono-Medium','GT-Pressura-Mono-Text',sans-serif !important;font-weight:600 !important;}";

    head.appendChild(style);
    return true;
  }

  function tryInject() {
    injectIntoFrame(document.getElementById('BIS_frame'));
  }

  function attachListeners(iframe) {
    if (!iframe || iframe.dataset.bisFontListeners === '1') return;
    iframe.dataset.bisFontListeners = '1';
    iframe.addEventListener('load', tryInject);
    new MutationObserver(tryInject).observe(iframe, {
      attributes: true,
      attributeFilter: ['style', 'src'],
    });
  }

  function setup() {
    var iframe = document.getElementById('BIS_frame');
    if (iframe) attachListeners(iframe);
    tryInject();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }

  new MutationObserver(function () {
    var iframe = document.getElementById('BIS_frame');
    if (iframe) attachListeners(iframe);
    tryInject();
  }).observe(document.documentElement, { childList: true, subtree: true });

  var n = 0;
  var intervalId = setInterval(function () {
    tryInject();
    n += 1;
    if (n > 60) clearInterval(intervalId);
  }, 250);
})();
